import * as React from 'react';

/**
 * @ignore - internal component.
 */
const TreeViewContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  TreeViewContext.displayName = 'TreeViewContext';
}
export default TreeViewContext;